const {
  runObjectExtender: baseRunObjectExtender
} = require('vue-js-extender');

exports.runObjectExtender = (Vue) => {
  baseRunObjectExtender(Vue);

  //------------------------- Object Extensions -------------------------
  //------------------------- End -------------------------
}



// WEBPACK FOOTER //
// ./src/core/js-extender/object.extender.js